// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportActivityEntity from './entities/report-activity.json';
import reportActivityMenu from '../pages/report-activity/menu.json';
import reportActivityFullForm from '../pages/report-activity/forms/full.json';
import reportActivityContextForm from '../pages/report-activity/forms/context.json';
import reportActivityMiniForm from '../pages/report-activity/forms/mini.json';
import reportActivityLookupForm from '../pages/report-activity/forms/lookup.json';
import reportActivityTableView from '../pages/report-activity/views/table.json';
import reportActivityCardsView from '../pages/report-activity/views/cards.json';
import reportActivityDashboardView from '../pages/report-activity/views/dashboard.json';

/** Тип запису «Діяльність у звіті» зі сторінками пакета: меню, форми та подання з pages/report-activity/. */
export const reportActivityDefinition: IRecordTypeDefinition = {
  ...reportActivityEntity,
  views: assembleViewSet({
      table: reportActivityTableView,
      cards: reportActivityCardsView,
      dashboard: reportActivityDashboardView,
  }),
  form: reportActivityFullForm,
  forms: { full: reportActivityFullForm, context: reportActivityContextForm, mini: reportActivityMiniForm, lookup: reportActivityLookupForm },
  menu: reportActivityMenu,
} as IRecordTypeDefinition;
